var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"face"},[_c('canvas',{staticStyle:{"margin":"0 auto","display":"block"},attrs:{"id":"canvas","width":"160px","height":"160px"}}),_c('div',{staticClass:"tips"},[_vm._v("请连接公司 WIFI，扫描二维码，录入人脸。一人一码，请勿分享")])])
}]

export { render, staticRenderFns }